import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';

/**
 * Re-frame the camera when the asset changes: a 20 m jet and a 4 m vehicle
 * cannot share one framing. Saves the controls state so "Reset view" returns
 * to this asset's framing rather than the first one loaded.
 * Shared by the home AssemblyStage and the ExplodedView workspace.
 */
export default function CameraRig({ config, controlsRef }) {
  const camera = useThree((s) => s.camera);
  const invalidate = useThree((s) => s.invalidate);
  useEffect(() => {
    camera.position.set(...config.position);
    camera.far = config.far;
    camera.updateProjectionMatrix();
    const controls = controlsRef.current;
    if (controls) {
      controls.target.set(...config.target);
      controls.update();
      controls.saveState();
    }
    invalidate();
  }, [config, camera, controlsRef, invalidate]);
  return null;
}
